import { render, staticRenderFns } from "./WordQuiz.vue?vue&type=template&id=f4189796&"
import script from "./WordQuiz.vue?vue&type=script&lang=js&"
export * from "./WordQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports